module.exports = __webpack_public_path__ + "static/media/01Demo Photo-ink-min.c05434d4.jpeg";